import React from 'react';
import {FormikSingleCheckBox} from './type/FormikSingleCheckBox';
import {RawSingleCheckBox} from './type/RawSingleCheckBox';
import {ClickableOptionWrapper} from '../ClickableFormStructure';
import {FormSelectionBox} from '../../../../shared-components/forms/formSelectSetup';

export function SingleCheckBox({raw, ...props}) {
    if (raw) {
        return <RawSingleCheckBox {...props} />;
    } else {
        return <FormikSingleCheckBox {...props} />;
    }
}

SingleCheckBox.Box = FormSelectionBox;
SingleCheckBox.Wrapper = ClickableOptionWrapper;
export {ClickableOptionWrapper};
